import { AfterViewInit, ChangeDetectorRef, OnDestroy, OnInit, Directive } from "@angular/core";
import { LogCategory, LoggerService, LogType } from "../../core/services/logger.service";
import { ProfileService } from "../../core/services/profile.service";
import { Widget } from "./widget";

@Directive()
export class WidgetHostBaseComponent implements OnInit, OnDestroy, AfterViewInit {

    public widgets: Widget[] = [];
    public isDataLoaded: boolean = false;
    public sortableOptions = {};

    constructor(
        public moduleName: string,
        private profile: ProfileService,
        private logger: LoggerService,
        private logType: LogType,
        private logComponent : number,
        private changeDetector: ChangeDetectorRef
    ) {
        this.sortableOptions = {
            onUpdate: (event: any) => {
                this.updateWidgetPlacement(event);
            },
            animation: 150,
            handle: '.drag-handle',
            forceFallback: true,
        };

        this.log("constructor", null, LogCategory.Constructor);
    }
    private log(method: string = null, message = null, category: LogCategory = LogCategory.Default): void {
        method = (method) ? '.' + method + '()' : '';
        message = (message) ? message.toString() : '';
        this.logger.try(this.moduleName + method + ': ' + message, this.logType, this.logComponent, category);
    }

    public onWidgetsLoaded(data: Widget[]) {
        this.log("onWidgetsLoaded", data.map(a => a.meta.Name));        
        this.widgets = data;
        this.isDataLoaded = true;
    }

    public updateWidgetPlacement(event: any) {
        const names = this.widgets.map(a => a.meta.Name);
        this.profile.updateWidgetPlacement(this.moduleName, names);
        this.log("updateWidgetPlacement", names);
    }

    ngOnInit() {
        this.log("ngOnInit", null, LogCategory.Init);
    }
    ngOnDestroy() {
        this.log("ngOnDestroy", "", LogCategory.Destroy);
    }

    ngAfterViewInit() {
        // See https://blog.angularindepth.com/everything-you-need-to-know-about-the-expressionchangedafterithasbeencheckederror-error-e3fd9ce7dbb4 
        this.changeDetector.detectChanges();
    }
}
